import React, { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import { obtenerLabelEtiqueta } from "../../utils/idioma/LabelsIdioma";

const ModalyaRegistrado = () => {

  const {listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});

  useEffect(() => {
    
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        lbl_horario_ver_horario: obtenerLabelEtiqueta(
          "lbl_horario_ver_horario",
          listadoEtiquetas
        ),
        lbl_horario_msj_registrado: obtenerLabelEtiqueta(
          "lbl_horario_msj_registrado",
          listadoEtiquetas
        ),
        lbl_horario_msj_ver_horario: obtenerLabelEtiqueta(
          "lbl_horario_msj_ver_horario",
          listadoEtiquetas
        )
      });
    }
  }, [listadoEtiquetas]);
  const { lbl_horario_ver_horario,
    lbl_horario_msj_registrado,
    lbl_horario_msj_ver_horario} = etiquetas;

  return (
    <div
      className="modal fade"
      id="horarioregistrado"
      tabIndex={-1}
      data-bs-backdrop="static"
      aria-labelledby="exampleModalLabelhorario"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body pb-0 pt-4">
            <div className="text-center">
              <div className=" va-middle add-cart">
                <div className="success-animation">
                  <svg
                    className="checkmark-animation"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 52 52"
                  >
                    <circle
                      className="checkmark__circle"
                      cx={26}
                      cy={26}
                      r={25}
                      fill="none"
                    />
                    <path
                      className="checkmark__check"
                      fill="none"
                      d="M14.1 27.2l7.1 7.2 16.7-16.8"
                    />
                  </svg>
                </div>
              </div>
              <h5 className="text-uppercase ">
                
                {lbl_horario_msj_ver_horario}
              </h5>
              <p>{lbl_horario_msj_registrado}.</p>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-primary" data-bs-dismiss="modal"
            aria-label="Close">
              {lbl_horario_ver_horario}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalyaRegistrado;
